<h1 mat-dialog-title> {{ 'internalEquipmentEdit.balanceMass.data.title' | translate }}</h1>
<form>
  <div fxLayout="row">
    <div fxFlex="100" fxFlex.lt-md="100%">
      <mat-form-field class="campoFormulario">
        <mat-label>{{ 'internalEquipmentEdit.balanceMass.unit.label' | translate }}</mat-label>
        <mat-select name="unit" [(ngModel)]="data.item.idUnit" required
          (selectionChange)="onUnitChange($event)">
          @for (item of variableUnits; track item) {
            <mat-option [value]="item.id">
              {{item.unit}}
            </mat-option>
          }
        </mat-select>
        <mat-error>
          {{ 'internalEquipmentEdit.balanceMass.cols.unit.error' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
  </div>
  <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
    <div fxFlex="50" fxFlex.lt-md="100%">
      <mat-form-field class="campoFormulario">
        <mat-label>{{ 'internalEquipmentEdit.balanceMass.cols.mass.label' | translate }}</mat-label>
        <input matInput [pattern]="numberRegexp" name="mass" [(ngModel)]="data.item.mass">
        <mat-error>
          {{ 'internalEquipmentEdit.balanceMass.cols.mass.error' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <div fxFlex="50" fxFlex.lt-md="100%">
      <mat-form-field class="campoFormulario">
        <mat-label>{{ 'internalEquipmentEdit.balanceMass.cols.massId.label' | translate }}</mat-label>
        <input matInput [pattern]="numberRegexp" name="massId" [(ngModel)]="data.item.idMass">
      </mat-form-field>
    </div>
  </div>
  <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
    <div fxFlex="50" fxFlex.lt-md="100%">
      <mat-form-field class="campoFormulario">
        <mat-label>{{ 'internalEquipmentEdit.balanceMass.cols.physicalValue.label' | translate }}</mat-label>
        <input matInput [pattern]="numberRegexp" name="physicalValue" [(ngModel)]="data.item.valuePhysical">
        <mat-error>
          {{ 'internalEquipmentEdit.balanceMass.cols.physicalValue.error' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <div fxFlex="50" fxFlex.lt-md="100%">
      <mat-form-field class="campoFormulario">
        <mat-label>{{ 'internalEquipmentEdit.balanceMass.cols.utip.label' | translate }}</mat-label>
        <input matInput [pattern]="numberRegexp" name="utip" [(ngModel)]="data.item.uncertaintyTypical">
        <mat-error>
          {{ 'internalEquipmentEdit.balanceMass.cols.utip.error' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div mat-dialog-actions class="calibrates-theme">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick()" cdkFocusInitial>{{ 'button.save' | translate
    }}</button>
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>
</form>